import React, { useState } from "react";
import { Space, Modal, Typography, Row, Col, Button, Table, Flex, Alert, theme,Tag, Tooltip, Divider } from 'antd';
import { RenderLimitedChips } from "../../../../../../styleguide"
import { region_title_index_map } from "../../../../../../constants";
import { IAB_CHOICES_SYSTEM_IDS, USNAT_CODE } from "../../../helper";
const { Title, Text, Paragraph } = Typography;

const AddIabChoicesModal = (props) => {

  const {
    cancelBtnTextAndOpenIabModal,
    handleCancel,
    addCategory,
    systemPurposes,
    disabledSellOrShare,
    stateStringRegions
  } = props;

  const { token } = theme.useToken()
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleAddIabChoices = () => {
    addCategory(selectedRowKeys)
  }

  let footer = (
    <Flex vertical gap={16} align="flex-start">
      {props.isNoFrameworkFlow ? null : (
        <>
          <Text>Access detailed <a target="_blank" href="https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/tree/main/Sections/US-States">technical specifications</a> of IAB's state-level string requirements.</Text>
          <Divider style={{margin: 0}}/>
        </>
      )}
      <Flex justify="flex-end" style={{width: "100%"}}>
        <Button type='link' onClick={() => handleCancel('iab')}>{cancelBtnTextAndOpenIabModal}</Button>
        <Button disabled={systemPurposes.length === 0} type='primary' onClick={handleAddIabChoices} >Add selected choices {selectedRowKeys.length ? `(${selectedRowKeys.length})` : null}</Button>
      </Flex>
    </Flex>
  )



  let iabChoices = systemPurposes.map((item, index) => ({
    ...item,
    key: item.id || index,
  }));

  let regionFilterOptions = props.systemPurposes.reduce((regionCodes, currPurpose) => {
    let usCodes = Object.keys(currPurpose.configByGeo).filter((key) => stateStringRegions[key] || key === USNAT_CODE);
    regionCodes = [...new Set(regionCodes.concat(usCodes))]
    return regionCodes;
  },[]);

  regionFilterOptions = regionFilterOptions.map((usCode) => { 
    let isUsNat = usCode === USNAT_CODE;
    return (
      {
        text: (<><Tag color={isUsNat ? "green" : null}>{isUsNat ? "US NAT" : usCode.split("_")[1]}</Tag> - {isUsNat ? "US National" : region_title_index_map[usCode.replace("US_","STATE_")]}</>),
        value: usCode,
        searchValue: isUsNat ? "US National" : region_title_index_map[usCode.replace("US_","STATE_")]
      }
    )
  }) 

  const columns = [
    {
      title: "Privacy Choice",
      fixed: "left",
      dataIndex: "privacyChoice",
      width: 250,
      sorter: (a, b) => a.privacyChoice.localeCompare(b.privacyChoice),
      render: (privacyChoice, record) => <Paragraph ellipsis={{tooltip:{title: privacyChoice}, rows: 2}}>{privacyChoice}</Paragraph>
    }
  ]

  if(!props.isNoFrameworkFlow) {
    columns.push(
      {
        title: "Applies to",
        fixed: "left",
        dataIndex: "configByGeo",
        width: 350,
        filters: regionFilterOptions,
        onFilter: (value, record) => {
          return Object.keys(record.configByGeo).includes(value)
        },
        filterSearch: (input, record) => {
          return record.searchValue.toLowerCase().includes(input.toLowerCase());
        },
        sorter: (a, b) => Object.keys(a.configByGeo)?.length - Object.keys(b.configByGeo)?.length,
        render: (configByGeo, record) => {
          let states = configByGeo ? Object.keys(configByGeo) : []
          states = states.sort((a, b) => (a === USNAT_CODE ? -1 : b === USNAT_CODE ? 1 : 0));
          const stateTags = states.map((s,i) => {
            const stateCode = s.split("_")[1]
            return (
            <Tooltip
              title={s === USNAT_CODE ? null : region_title_index_map[s.replace("US_", "STATE_")]}
            >
            <Tag color={s === USNAT_CODE ? "green" : null}>{s === USNAT_CODE ? "US NAT": stateCode}</Tag>
            </Tooltip>
          )
          })
          return (
            <RenderLimitedChips chips={stateTags} cutOff={5} />
          )
        }
      }
    )
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys)
    },
    getCheckboxProps: (record) => ({
      disabled: disabledSellOrShare && record.systemId === IAB_CHOICES_SYSTEM_IDS.saleAndSharing,
    }),
  };

    return (
      <Modal
        title={props.isNoFrameworkFlow ? "Add Standard Choice" : "Add IAB Choices"}
        open={cancelBtnTextAndOpenIabModal}
        width={"720px"}
        closable={true}
        destroyOnClose={true}
        onCancel={() => handleCancel('iab')}
     //   confirmLoading={vendorConnectionsSavePending}
        footer={footer}
        style={{
          top: 20
        }}
      >
        <Row gutter={[0, 16]} className='row-gutter'>
          <Col span={24}>
            <Space direction="vertical" size={token.margin}>
            <Text type="secondary">
                {props.isNoFrameworkFlow
                  ? "Select from these commonly configured US state privacy choices."
                  : "Select the IAB categories you want to add to your list:"}
              </Text>
            </Space>
          </Col>
          <Col span={24}>
            <Table
              columns={columns}
              // style={{ height: "500px", overflow:'auto'}}
              scroll={{y: 400}}
              dataSource={iabChoices}
              rowSelection={rowSelection}
              pagination={false}
            />
            </Col>
        </Row>
      </Modal>
    )
  
}

export default AddIabChoicesModal